import React from 'react';
import styled from 'styled-components';
import Card from '../../UI/Card';
import LocationInfo from './LocationInfo';
import DeskTry from './DeskTry';
import {headerHeight} from '../../mixins';


const StyledCardsBlock = styled.div`
  position: absolute;
  top: calc(${headerHeight} + 20px);
  left: 1%;
  z-index: 1500;
  width: auto;
  min-height: 460px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
  div {
    margin-bottom: 16px;
  }

    >* {
        position: relative;
        z-index: 1500;
    }
`

const CardsBlock = () => (
    <StyledCardsBlock>
        <Card>
            <LocationInfo/>
        </Card>
        <DeskTry/>
    </StyledCardsBlock>
);


export default CardsBlock;